<template>
  <option-general value="until_action" :label="$t('edit.sidebar.until_action')"></option-general>
</template>

<script>
import OptionGeneral from './general/Main.vue';

export default {
  components: {
    OptionGeneral,
  },
};
</script>



/** WEBPACK FOOTER **
 ** UntilAction.vue?fe30306c
 **/